import XSearch from './XSearch'

export default XSearch
